'use strict';

angular
  .module('ClinicApp')
  .directive('ocTooltip', ($timeout) => ({
    restrict: 'E',
    transclude: true,
    templateUrl: '/views/directives/tooltip.html',
    scope: {
      text: '=',
    },
    link: ($scope, $element) => {
      $scope.hasText = Boolean($scope.text);

      const getTooltip = () => $element.find('.tooltip-content')[0];
      const getParent = () => $element.find('.tooltip-container')[0];

      // Move tooltip to make sure it doesn't go off the screen
      const checkTooltipPosition = () => {
        const tooltip = getTooltip();
        const parent = getParent();

        if (!tooltip || !parent) {
          return;
        }

        // Set the max width to initial to allow the tooltip to grow
        tooltip.style.maxWidth = 'initial';

        const tooltipRect = tooltip.getBoundingClientRect();
        const parentRect = parent.getBoundingClientRect();
        const windowWidth = document.documentElement.clientWidth;

        const isOverflowingLeft = tooltipRect.left < 0;
        const isOverflowingRight = tooltipRect.right > windowWidth;
        const isOverflowingTop = tooltipRect.top < 0;
        // Can't overflow bottom because we're using translateY
        // If the parent is hovered then the parent must be on screen
        // and the tooltip will be on top of the parent

        const parentCenterX = parentRect.width / 2;
        const targetX = parentCenterX - tooltipRect.width / 2;

        if (isOverflowingRight) {
          const overflowAmount = tooltipRect.right - windowWidth;
          const newLeft = targetX - overflowAmount;
          tooltip.style.left = `${newLeft}px`;
        }

        if (isOverflowingLeft) {
          const overflowAmount = -tooltipRect.left;
          const newLeft = targetX + overflowAmount;
          tooltip.style.left = `${newLeft}px`;
        }

        if (isOverflowingTop) {
          const overflowAmount = -tooltipRect.top;
          tooltip.style.top = `${overflowAmount}px`;
        }
      };

      $scope.isVisible = false;
      $element.on('mouseenter', () => {
        $scope.isVisible = true;
        $timeout(checkTooltipPosition, 1);
        $scope.$apply();
      });

      $element.on('mouseleave', () => {
        $scope.isVisible = false;
        $scope.$apply();
      });

      $scope.checkTooltipPosition = checkTooltipPosition;
    },
  }));
